<script setup lang="ts">
import { PropType, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import { toastApiResult } from "@/toaster";
import GeneralUserSettings from "@/modules/users/components/GeneralUserSettings.vue";
import { passwordFieldsType } from "@/api/resources/users";

const props = defineProps({
	user: {
		type: Object as PropType<App.Data.UserDO>,
		require: true,
	},
});

const emit = defineEmits(["update-user"]);

const updateUser = async (user: App.Data.UserDO) => {
	const response = await toastApiResult(useApiClient("users").updateUser(user));
	if (response.isOk()) {
		emit("update-user", response.value);
	}
};

const updatePassword = async (passwordFields: passwordFieldsType) => {
	const response = await toastApiResult(
		useApiClient("users").updateUserPassword(props.user, passwordFields)
	);
	return response;
};
</script>

<template>
	<general-user-settings
		:user="props.user"
		:async-update-function="updateUser"
		:async-update-password-function="updatePassword"
		:is-profile-page="false"
	/>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
